// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Mn96d","label":"styles_label__2ujlx"};